import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import tournamentStatus from "../../constants/TournamentStatus";

class UpgradesTableRowContainer extends Component {
  state = {
    tournament: {},
  };

  UNSAFE_componentWillMount = () => {
    this.unsub = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.upgrade.tournamentId)
      .onSnapshot((doc) => {
        this.setState({ tournament: doc.data() || {} });
      });
  };

  componentWillUnmount = () => {
    this.unsub();
  };

  render() {
    const upgrade = this.props.upgrade;
    
    return (
      <TableRow>
        <TableCell style={{ whiteSpace: "nowrap", paddingRight: 0 }}>
          {moment.unix(upgrade.created).format("dd D MMM YY HH:mm")}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          <Link to={"/admin/" + upgrade.uid}>{upgrade.uid}</Link>
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          <Link to={"/tournament/" + upgrade.tournamentId}>
            {this.state.tournament.name || ""}
          </Link>
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {(upgrade.currentPackage === 1
            ? tournamentStatus[1].name.slice(0, 6) + ". > "
            : "") +
            tournamentStatus[upgrade.package].name.slice(0, 6) +
            (upgrade.package !== 3 ? "." : "") +
            (upgrade.iResCode ? " (25% discount)" : "")}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.revenue ? upgrade.revenue : ""}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.vat_percentage || ""}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.method || ""}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.currency || ""}
        </TableCell>
        <TableCell style={{ paddingRight: 0, whiteSpace: "nowrap" }}>
          {upgrade.invoiceStatus || ""}
        </TableCell>
        {/* <TableCell>{upgrade.tournamentId}</TableCell> */}
        {/* <TableCell>{upgrade.receiveInvoice ? "Yes" : "No"}</TableCell> */}
        <TableCell style={{ paddingRight: 0 }}>{upgrade.email}</TableCell>
        <TableCell style={{ paddingRight: 0 }}>{upgrade.firstName}</TableCell>
        <TableCell style={{ paddingRight: 0 }}>{upgrade.lastName}</TableCell>
        <TableCell style={{ paddingRight: 0 }}>{upgrade.companyName}</TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.address + " " + upgrade.zipCode + " " + upgrade.place}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.country || ""}
        </TableCell>
        <TableCell style={{ paddingRight: 0 }}>
          {upgrade.btwNum || ""}
        </TableCell>

        {/* <TableCell>{upgrade.ip_address || ""}</TableCell> */}
        <TableCell style={{ paddingRight: 0 }}>
          {(upgrade.redirectHostname || "")
            .replace("www.", "")
            .replace("tournifyapp", "")
            .replace("tournify", "")}
        </TableCell>
        <TableCell>{upgrade.language || ""}</TableCell>
      </TableRow>
    );
  }
}

export default UpgradesTableRowContainer;
